import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

class CommentUrl extends React.PureComponent {
    static propTypes = {
        docData: PropTypes.object,
    };

    /**
     * 渲染网页布局
     */
    render() {
        const { base62Id } = this.props.docData;
        // console.log(this.props);

        return (
            <li className={styles.message}>
                <a target="_blank" href={`//gentie.ifeng.com/c/comment/${base62Id}`} />
            </li>
        );
    }
}

export default errorBoundary(CommentUrl);
